module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1050-d8a3ab7fa641ffd245a3ecf1d23a24e2.png";